import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useUserAgent } from '@/helpers/composables/useUserAgent';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { computed } from 'vue';

const ATV_PLACEMENTS_EXP_PLACEMENT_MAP = {
	control: 'ft',
	variant_1: 'sqtv',
	variant_2: 'qtv',
	variant_3: 'ft',
	variant_4: 'sqtv',
	variant_5: 'qtv',
} as const;

export function useATVPlacementsExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('ATV_PLACEMENTS_EXP');
	const { deviceType } = useUserAgent();

	const atvPlacementsExpPlacement = computed(() => {
		if (!variant.value) return null;

		return ATV_PLACEMENTS_EXP_PLACEMENT_MAP[variant.value];
	});

	const atpExpHardcodedShortName = computed(() => (!!variant.value ? 'atp' : null));

	function setATVPlacementExpTags(url: ClickoutUrl) {
		if (!variant.value || !atvPlacementsExpPlacement.value) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		/*
		 * Fellow pirates - i am hoping we can have something like this to standardise the affiliate tag generation for all experiments
		 * would prefer it if we can use the experiment name, but I have moved that to a separate PR as it involves deeper TS changes in exp system
		 * 8020 - 80% of the time, it improves 20% of the code.
		 */

		const ct = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: 'US',
			placement: atvPlacementsExpPlacement.value,
			deviceType: deviceType.value,
		});

		return url.set('uct_ctag', ct);
	}

	return { atvPlacementsExpPlacement, setATVPlacementExpTags, atpExpHardcodedShortName };
}
